import { render, staticRenderFns } from "./Institutes.vue?vue&type=template&id=6ce556ee"
import script from "./Institutes.vue?vue&type=script&lang=js"
export * from "./Institutes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports